module.exports = __webpack_public_path__ + "8e82c66612cc1205a91544273cb9ecc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/Logo.svg
// module id = 153
// module chunks = 0